//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The OAuth token model
* 
* @param expires The expiry date of the access token
* @param issued The issued date of the access token
* @param tfgRefreshExpires The expiry date of the refresh token
* @param tfgRefreshExpiresIn Seconds to the expiration of the refresh token
* @param accessToken The access token
* @param expiresIn The expires duration in seconds
* @param refreshToken The refresh token
* @param tokenType The token type
*/
@Serializable

data class AuthToken (


      /* The expiry date of the access token */
    @SerialName(value = ".expires") @Required val expires: kotlin.String,


      /* The issued date of the access token */
    @SerialName(value = ".issued") @Required val issued: kotlin.String,


      /* The expiry date of the refresh token */
    @SerialName(value = ".tfg_refresh_expires") @Required val tfgRefreshExpires: kotlin.String,


      /* Seconds to the expiration of the refresh token */
    @SerialName(value = ".tfg_refresh_expires_in") @Required val tfgRefreshExpiresIn: kotlin.Int,


      /* The access token */
    @SerialName(value = "access_token") @Required val accessToken: kotlin.String,


      /* The expires duration in seconds */
    @SerialName(value = "expires_in") @Required val expiresIn: kotlin.Int,


      /* The refresh token */
    @SerialName(value = "refresh_token") @Required val refreshToken: kotlin.String,


      /* The token type */
    @SerialName(value = "token_type") @Required val tokenType: kotlin.String


) {




  }

